import { useCallback, useEffect } from "react"
import { Alert, Loader, Stack, SxProps, Tab, Tabs } from "@tm/components"
import { useAdvertisementCategories } from "@tm/data/erpConnect"
import { useLocalization } from "@tm/localization"
import { AdvertisementCategory } from "@tm/models"
import { useOffersStore } from "../../store"
import { OFFER_CAROUSEL_KEY } from "../../component"

type AdvertisementCategoriesProps = { sx?: SxProps; onChangeTab?: (id: string) => void }

export function AdvertisementCategories({ sx, onChangeTab }: AdvertisementCategoriesProps) {
    const { translateText } = useLocalization()

    const { advertisementCategories, advertisementCategoriesLoading, advertisementCategoriesInitialized } = useAdvertisementCategories(true)
    const { setCategories, setSelectedCategory, selectedCategory, setCurrentCarouselPageIndex } = useOffersStore()

    useEffect(() => {
        if (advertisementCategories) {
            setCategories(advertisementCategories)
        }
    }, [advertisementCategories, setCategories])

    useEffect(() => {
        if (advertisementCategoriesInitialized && advertisementCategories?.length && !selectedCategory) {
            setSelectedCategory(advertisementCategories[0])
        }
    }, [advertisementCategoriesInitialized, advertisementCategories, selectedCategory, setSelectedCategory])

    const handleChangeTab = useCallback(
        (_: React.SyntheticEvent, category: AdvertisementCategory) => {
            setCurrentCarouselPageIndex(0)
            setSelectedCategory(category)
            onChangeTab?.(OFFER_CAROUSEL_KEY)
        },
        [onChangeTab, setSelectedCategory, setCurrentCarouselPageIndex]
    )

    if (advertisementCategoriesLoading) {
        return <Loader size="extrasmall" />
    }

    if (!advertisementCategories?.length) {
        return <Alert severity="warning">{translateText(323)}</Alert>
    }

    if (!selectedCategory) {
        return null
    }

    return (
        <Stack direction="row" gap={1} sx={sx}>
            <Tabs value={selectedCategory} onChange={handleChangeTab} size="small">
                {advertisementCategories.map((category) => (
                    <Tab key={category.id} value={category} label={category.description} />
                ))}
            </Tabs>
        </Stack>
    )
}
